<template>
    <div>
        <div v-if="text == undefined">
            <b-input-group class="mb-3">
                <b-input-group-prepend>
                    <b-input-group-text>輸入字串/URL</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="form-control" v-model="target_options.text" />
                <b-button variant="success" :disabled="checkDisabled" @click="create_QRCode">產生 QR Code</b-button>
            </b-input-group>
        </div>

        <div v-if="type == undefined">
            <b-form-radio-group id="radio-group-2" v-model="target_type" name="radio-sub-component">
                <b-form-radio v-for="(type, key_type, idx_type) in list_types" :key="idx_type" :value="key_type"
                    @click="change_Type(key_type)"
                    class="block-sm clickable">
                    <span class="clickable">{{ type.name }}</span>
                </b-form-radio>
            </b-form-radio-group>
        </div>

        <div class="qr-display">
            <div ref="qrcode"></div>
        </div>
    </div>
</template>

<script>
import * as QRCode from 'easyqrcodejs'
// Document: https://github.com/ushelp/EasyQRCodeJS#options

export default {
    props: {
        text: {
            type: String,
            default: undefined,
        },
        type: {
            type: String,
            default: undefined,
        },
        title: {
            type: String,
            default: undefined,
        },
        sub_title: {
            type: String,
            default: undefined,
        },
    },
    data () {
        return {
            result_qrcode: undefined,
            target_type: undefined,
            target_logo: '',
            target_title_length: 30,
            target_options: {
                text: '',//'https://cloud.agriweather.online/farm/reports?id=2WdKOm49NRvZNvGrVByD&lang=en',
                width: 256,
                height: 256,
                colorDark: '#106651',
                quietZone: 40,
                // quietZoneColor: 'rgba(223, 255, 128, 0.2)',//'#dfff80',
                titleTop: -12,
                titleFont: 'bold 14px Noto Sans TC',
                subTitleTop: 256 + 10,
                subTitleFont: 'bold 12px Noto Sans TC',
            },

            list_types: {
                'monthly_report': {
                    name: this.$t('menu.monthly_report'),
                    title: this.$t('menu.monthly_report'),
                    logoBGTransparent: false,
                    logoWidth: 120, logoHeight: 35,
                    logo: this.$config.getAssetsURL('img/brand/logo5.png'),

                    PO_TL: '#862d59', // Posotion Outer color - Top Left
                    PI_TL: '#333399', // Posotion Inner color - Top Left
                },
                'period_report': {
                    name: this.$t('menu.period_report'),
                    title: this.$t('menu.period_report'),
                    logoBGTransparent: false,
                    logoWidth: 120, logoHeight: 35,
                    logo: this.$config.getAssetsURL('img/brand/logo5.png'),

                    PO_TL: '#00b3b3', // Posotion Outer color - Top Left
                    PI_TL: '#0066ff', // Posotion Inner color - Top Left
                },
                'default': {
                    name: 'Default',
                    title: 'AgriWeather',
                    // title: '一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十',
                    logoBGTransparent: false,
                    logoWidth: 120, logoHeight: 35,
                    logo: this.$config.getAssetsURL('img/brand/logo5.png'),
                },
                'default2': {
                    name: 'Default 2',
                    title: 'AgriWeather',
                    logoBGTransparent: false,
                    logoWidth: 60, logoHeight: 60,
                    logo: this.$config.getAssetsURL('img/brand/Agri_Icon_App.png'),
                },
            },
        }
    },
    mounted ()
    {
        this.change_Type( this.type )
    },
    computed: {

        checkDisabled ()
        {
            if ( this.target_options.text == '' ) return true
            if ( this.target_options.text == undefined ) return true
            return false
        },

    },
    watch: {

        text (val, oldVal) { this.create_prepare() },
        title (val, oldVal) { this.create_prepare() },
        sub_title (val, oldVal) { this.create_prepare() },

        type (val, oldVal)
        {
            this.change_Type( val )
        },

        target_type (val, oldVal)
        {
            this.create_prepare()
        },

    },
    methods: {

        create_prepare ()
        {
            this.get_TypeSettings( this.target_type, this.target_options )

            if (this.checkDisabled == false)
            {
                this.create_QRCode()
            }
        },

        shorten_String (text, length = 10)
        {
            return text.slice(0, length) + ( text.length > length ? '...' : '' )
        },

        change_Type (type)
        {
            if ( type && this.list_types[ type ] )
            {
                this.target_type = type
            }
            else this.target_type = 'default'
        },

        get_TypeSettings (type, options)
        {
            let _setting = this.list_types[ type ]
            options.logo = _setting.logo
            options.logoBackgroundTransparent = _setting.logoBGTransparent

            if ( _setting.logoWidth != undefined && _setting.logoHeight != undefined )
            {
                options.logoWidth = _setting.logoWidth
                options.logoHeight = _setting.logoHeight
            }

            if ( this.title != undefined ) options.title = this.shorten_String( this.title, this.target_title_length )
            else options.title = this.shorten_String( _setting.title, this.target_title_length )


            if ( this.sub_title != undefined ) options.subTitle = this.shorten_String( this.sub_title, this.target_title_length )

            if ( this.text != undefined ) options.text = this.text

            options.PO_TL = _setting.PO_TL
            options.PI_TL = _setting.PI_TL
        },

        create_QRCode ()
        {
            this.$refs.qrcode.innerHTML = ''
            this.result_qrcode = new QRCode( this.$refs.qrcode, this.target_options );
            // console.log( this.target_options )
            // console.log( this.result_qrcode )
            // console.log( this.$refs.qrcode )
        },

    },
}
</script>

<style lang="scss" scoped>

.qr-display
{
    text-align: center;
    padding: 20px 0px;

    overflow-x: auto;
    overflow-y: hidden;
}

</style>
